module.exports = __webpack_public_path__ + "img/connection-left-2.4ca53bfb.png";